
import Swiper from 'swiper/bundle';

export default () => {
    /**
    * Set class when header is fixed
    * @param {*} ev
    */

    /**
     * Init product slider with swiper
     */
    const swipers = document.querySelectorAll('.swiper.products-wrapper');
    if (swipers) {
        swipers.forEach(function (el) {
            let slider = new Swiper(el, {
                slidesPerView: 3,
                slidesPerGroup: 1,
                centeredSlides: false,
                spaceBetween: 15,
                loop: true,
                autoplay: true,
                simulateTouch: false,
                pagination: false,
                lazy: {
                    loadPrevNext: true,
                },
            });
            el.parentElement.querySelector('.arrow-button').addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                slider.slideNext();
            });
        });
    }
}
